<template>
  <div class="controles">
    <v-btn-toggle :value="tipoLocal" toggle_none class="d-flex col-12 pb-0 px-0">
      <v-btn class="flex-fill" :value="0" @click="setTipo(0)">
        <v-icon class="mr-2">mdi-barcode-scan</v-icon>
        Pistola
      </v-btn>
      <v-btn class="flex-fill" :value="1" @click="setTipo(1)">
        <v-icon class="mr-2">mdi-camera-outline</v-icon>
        Camara
      </v-btn>
      <v-btn class="flex-fill" :value="2" @click="setTipo(2)">
        <v-icon class="mr-2">mdi-hand-wave-outline</v-icon>
        Manual
      </v-btn>
    </v-btn-toggle>

    <v-card v-if="tipoLocal === 1" class="col-12 pa-0 ma-0 border-rounded-0">
      <Scan @search-by-ean-code="onScanFromChild" />
    </v-card>

    <v-card v-if="tipoLocal === 2" class="d-flex py-0 px-6 ma-0">
      <v-text-field class="buscar mt-0 px-4" clearable id="textEanManual" text ref="textEanManual" label="Ean"
        v-model.lazy.trim="ean" @keydown.enter="emitScan"></v-text-field>
      <v-icon class="mr-5 primary--text">mdi-barcode</v-icon>
    </v-card>

    <v-text-field class="buscar pt-4 hidden-ean-input" id="textEan" text ref="textEan" label="Ean"
      v-model.lazy.trim="ean" @keydown.enter="emitScan" v-if="tipoLocal === 0"></v-text-field>
  </div>
</template>

<script>
import Vue from 'vue';
import Scan from './Shop/scan.vue';

export default Vue.extend({
  name: 'EanReader',
  components: {
    Scan
  },
  props: {
    tipo: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tipoLocal: this.tipo,
      ean: ''
    }
  },
  watch: {
    tipo(val) {
      this.tipoLocal = val
    }
  },
  mounted() {
    this.focusInput(this.tipoLocal)
  },
  methods: {
    setTipo(val) {
      this.tipoLocal = val
      this.$emit('update:tipo', val)
      this.focusInput(val)
    },
    focusInput(val) {
      this.$nextTick(() => {
        const ref = val === 0 ? this.$refs.textEan : val === 2 ? this.$refs.textEanManual : null
        if (ref && ref.focus) this.waitVisibleAndFocus(ref, Date.now())
      })
    },
    // el input puede estar oculto (v-show en un ancestro) mientras App.vue
    // resuelve la comprobación de certificado, y focus() no hace nada sobre
    // un elemento no visible, así que reintentamos hasta que sea visible
    waitVisibleAndFocus(ref, startedAt) {
      if (this._isDestroyed) return
      const el = ref.$el || ref
      if (el && el.offsetParent !== null) {
        ref.focus()
      } else if (Date.now() - startedAt < 5000) {
        requestAnimationFrame(() => this.waitVisibleAndFocus(ref, startedAt))
      }
    },
    emitScan() {
      const val = (this.ean || '').trim()
      if (!val) return
      this.$emit('scan', val)
      this.ean = ''
      if (this.tipoLocal === 0) {
        this.focusInput(0)
      }
    },
    onScanFromChild(ean) {
      this.$emit('scan', ean)
    }
  }
})
</script>

<style scoped>
/* .controles {
  margin-bottom: 8px;
} */

.hidden-ean-input {
  position: absolute !important;
  left: -9999px !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: 0 !important;
  opacity: 0 !important;
  overflow: hidden !important;
}
</style>
